import { Button } from '@mui/material'
import React, { useState, useEffect } from 'react'
import { Wheel } from 'react-custom-roulette'
import Logo from '../../../assets/images/logo.png'
import { getRouletteOptions } from '../../../api/roulette'

interface RouletteWheelProps {
  show: boolean
  onStopSpinning: (selectedOption: string) => void
  onSpin: () => Promise<{ prize: string }>
  t: (key: string) => string
  prizeNumber: number
  setPrizeNumber: (prizeNumber: number) => void
}

const RouletteWheel: React.FC<RouletteWheelProps> = ({
  show,
  onStopSpinning,
  onSpin,
  t,
  prizeNumber,
  setPrizeNumber,
}) => {
  const [mustSpin, setMustSpin] = useState(false)

  const [data, setData] = useState<
    { option: string; style: { backgroundColor: string; textColor: string } }[]
  >([])

  useEffect(() => {
    const fetchRouletteOptions = async () => {
      try {
        const response = await getRouletteOptions()

        setData(response.data)
      } catch (error) {
        console.error('Error fetching roulette options:', error)
      }
    }

    fetchRouletteOptions()
  }, [])

  const handleSpinClick = async () => {
    if (!mustSpin && data.length > 0) {
      try {
        const response = await onSpin()
        const winningPrize = response.prize

        const winningIndex = data.findIndex(
          (item) => item.option === winningPrize
        )

        if (winningIndex !== -1) {
          setPrizeNumber(winningIndex)
          setMustSpin(true)

          localStorage.setItem('rouletteWinningPrize', winningPrize)
        } else {
          console.error('Winning prize not found in options')
        }
      } catch (error) {
        console.error('Error spinning roulette:', error)
      }
    }
  }

  if (!show || data.length === 0) {
    return null
  }

  return (
    <div className='roulette-overlay'>
      <div className='roulette-container'>
        <div className='wheel-wrapper' style={{ position: 'relative' }}>
          <Wheel
            mustStartSpinning={mustSpin}
            prizeNumber={prizeNumber}
            data={data}
            onStopSpinning={() => {
              const winningPrize =
                localStorage.getItem('rouletteWinningPrize') ||
                data[prizeNumber].option

              localStorage.removeItem('rouletteWinningPrize')
              onStopSpinning(winningPrize)
              setMustSpin(false)
            }}
            outerBorderWidth={5}
            innerBorderWidth={15}
            radiusLineWidth={2}
            radiusLineColor=''
            outerBorderColor='white'
            fontSize={16}
            perpendicularText={false}
            textDistance={60}
          />
          <button
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '80px',
              height: '80px',
              borderRadius: '50%',
              backgroundColor: '#ff1647',
              color: 'white',
              border: 'none',
              fontWeight: 'bold',
              cursor: 'default',
              zIndex: 10,
              fontSize: '18px',
            }}
          >
            <img
              src={Logo}
              alt='logo'
              style={{ width: '50px', height: '50px', marginTop: '5px' }}
            />
          </button>
        </div>

        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Button
            variant='contained'
            color='primary'
            size='large'
            onClick={handleSpinClick}
            disabled={mustSpin || data.length === 0}
            sx={{
              fontWeight: 'bold',
              fontSize: '18px',
              padding: '10px 30px',
              borderRadius: '25px',
              boxShadow: 3,
              backgroundColor: '#ff1647',
              '&:hover': {
                backgroundColor: '#cc1138',
                boxShadow: 6,
              },
            }}
          >
            {mustSpin ? t('SPINNING') : t('SPIN')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default RouletteWheel
